export const ProductStorageIcon = ({
  color = "#0F2C52",
}: {
  color?: string;
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.08268 6.25H12.0827C12.0827 6.25 12.4993 6.25 12.4993 6.66667V10.8333C12.4993 10.8333 12.4993 11.25 12.0827 11.25H7.08268C7.08268 11.25 6.66602 11.25 6.66602 10.8333V6.66667C6.66602 6.66667 6.66602 6.25 7.08268 6.25Z"
        fill={color}
      />
      <path
        d="M10.4167 12.0834H15.4167C15.4167 12.0834 15.8333 12.0834 15.8333 12.5V16.6667C15.8333 16.6667 15.8333 17.0834 15.4167 17.0834H10.4167C10.4167 17.0834 10 17.0834 10 16.6667V12.5C10 12.5 10 12.0834 10.4167 12.0834Z"
        fill={color}
      />
      <path
        d="M3.75065 12.0834H8.75065C8.75065 12.0834 9.16732 12.0834 9.16732 12.5V16.6667C9.16732 16.6667 9.16732 17.0834 8.75065 17.0834H3.75065C3.75065 17.0834 3.33398 17.0834 3.33398 16.6667V12.5C3.33398 12.5 3.33398 12.0834 3.75065 12.0834Z"
        fill={color}
      />
      <path
        d="M10 0C7.34784 0 4.8043 1.05357 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10L0 19.1667C0 19.3877 0.0877974 19.5996 0.244078 19.7559C0.400358 19.9122 0.61232 20 0.833333 20H19.1667C19.3877 20 19.5996 19.9122 19.7559 19.7559C19.9122 19.5996 20 19.3877 20 19.1667V10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0ZM17.5 18.3333H2.5C2.27899 18.3333 2.06702 18.2455 1.91074 18.0893C1.75446 17.933 1.66667 17.721 1.66667 17.5V10.2917C1.63469 8.14084 2.41619 6.05728 3.85476 4.45801C5.29332 2.85875 7.2828 1.86179 9.425 1.66667C10.5667 1.5877 11.7125 1.74475 12.7909 2.12803C13.8693 2.51131 14.8571 3.11261 15.6929 3.89445C16.5287 4.67629 17.1945 5.6219 17.6487 6.67234C18.103 7.72278 18.3361 8.85554 18.3333 10V17.5C18.3333 17.721 18.2455 17.933 18.0893 18.0893C17.933 18.2455 17.721 18.3333 17.5 18.3333Z"
        fill={color}
      />
    </svg>
  );
};
